export default __webpack_public_path__ + "static/media/XCV.a8f94abd.svg";